import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { isWorkerRole } from '../utils/roles.js';
import { ALINEA_PROFILES } from '../utils/constants.js';
import FunctionalEvolutionCard from '../components/FunctionalEvolutionCard.jsx';
import './Profile.css';

/**
 * Cuenta del operario: datos básicos y enlaces.
 * (El cuestionario de perfil vive en /profile-quiz — «Registro de manada».)
 */
export default function WorkerAccount() {
    const { user, logout } = useAuth();
    const isWorker = isWorkerRole(user?.rol);
    const profileKey = user?.perfil_alinea;
    const profile = profileKey ? ALINEA_PROFILES[profileKey] : null;

    return (
        <div className="container animate-in" style={{ maxWidth: '520px', margin: '0 auto', padding: '2rem 1.25rem 4rem' }}>
            <header style={{ marginBottom: '1.75rem' }}>
                <h1 style={{ fontSize: '1.5rem', fontWeight: 600, margin: '0 0 0.5rem' }}>Tu cuenta</h1>
                <p className="text-muted" style={{ margin: 0, lineHeight: 1.5 }}>
                    Datos de tu acceso en ALINEA. Si necesitas cambiar contraseña u otros datos administrativos, pide apoyo a tu
                    responsable.
                </p>
            </header>

            <div className="glass-card" style={{ padding: '1.35rem', marginBottom: '1.25rem' }}>
                <dl style={{ margin: 0, display: 'grid', gap: '0.85rem' }}>
                    <div>
                        <dt className="text-muted text-xs" style={{ textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                            Nombre
                        </dt>
                        <dd style={{ margin: '0.2rem 0 0', fontWeight: 600 }}>{user?.nombre_completo || '—'}</dd>
                    </div>
                    <div>
                        <dt className="text-muted text-xs" style={{ textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                            Código
                        </dt>
                        <dd style={{ margin: '0.2rem 0 0', fontWeight: 600 }}>{user?.code || '—'}</dd>
                    </div>
                    {user?.tenantName != null && (
                        <div>
                            <dt className="text-muted text-xs" style={{ textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                                Empresa
                            </dt>
                            <dd style={{ margin: '0.2rem 0 0' }}>{user.tenantName}</dd>
                        </div>
                    )}
                    {user?.areaName != null && (
                        <div>
                            <dt className="text-muted text-xs" style={{ textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                                Área
                            </dt>
                            <dd style={{ margin: '0.2rem 0 0' }}>{user.areaName}</dd>
                        </div>
                    )}
                    {profile && (
                        <div>
                            <dt className="text-muted text-xs" style={{ textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                                Perfil en ALINEA
                            </dt>
                            <dd style={{ margin: '0.35rem 0 0', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <span style={{ fontSize: '1.35rem' }}>{profile.emoji}</span>
                                <span>{profile.name?.replace(/\s*\([^)]*\)\s*/g, ' ').trim()}</span>
                            </dd>
                        </div>
                    )}
                </dl>
            </div>

            <FunctionalEvolutionCard />

            {isWorker && (
                <p style={{ margin: '0 0 1rem', fontSize: '0.95rem' }}>
                    <Link to="/profile-quiz" className="text-primary" style={{ fontWeight: 600 }}>
                        Registro de manada
                    </Link>
                    {' — '}
                    <span className="text-muted">opcional; ayuda a personalizar tu experiencia.</span>
                </p>
            )}

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
                <Link to="/apoyos" className="btn btn-secondary">
                    ← Volver a Apoyos
                </Link>
                <Link to="/" className="btn btn-secondary">
                    Ir a Jornada
                </Link>
                <button type="button" className="btn btn-primary" onClick={() => logout()}>
                    Cerrar sesión
                </button>
            </div>
        </div>
    );
}
